import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lowercaseEmail',
  standalone: false,
})
export class LowercaseEmailPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return value as string;

    return String(value).trim().toLowerCase();
  }
}
